import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { environment } from '../../../environments/environment';
import { map, Observable } from 'rxjs';
import { UtilityService } from '../utility/utility.service';

@Injectable({
  providedIn: 'root'
})
export class PayslipService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
    private utility: UtilityService,
  ) {
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }

  GetPayslip(Detail: any): Observable<any> {
    return this.utility.callWithRetry('GetEmpPayslip/MonthYear', Detail);
    // return this.http.post<any>(environment.API_URL + `GetEmpPayslip/MonthYear`,
    //   this.session.SetClass(Detail)
    // ).pipe(map(response => {
    //   if (response.Error_Code == '11' || response.Error_Code == '02') {
    //     this.session.End();
    //   } else {
    //     return response;
    //   }
    // }));
  }

  GeneratePayslip(Detail: any) {
    return this.http.post<any>(environment.API_URL + `GeneratePayslip/Empwise`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
